import rejectAfter from './rejectAfter';
import TimeoutError from './TimeoutError';

export default function timeout(promise, ms = 0) {
    if (ms) {
        const error = new TimeoutError(ms);
        return Promise.race([promise, rejectAfter(ms, error)]);
    }
    return promise;
}
